import { Box, Container } from '@mui/material';
import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';

import { addLocalePrefix } from 'utils/routes.utils';

import { Routes } from 'constants/routes.constants';
import { useLocale } from 'hooks/useLocale';
import { useAccount } from 'restful/accounts';

import AccountNavigation from 'components/@account/AccountNavigation';
import Authentication from 'components/@account/Authentication';
import DownloadApp from 'components/@account/DownloadApp';
import LoadingScreen from 'components/@common/LoadingScreen';
import PageBreadcrumbs from 'components/@navigation/PageBreadcrumbs';

import AuthenticatedSection from './AuthenticatedSection';
import SettingLinksList from './SettingLinksList';

const AccountContainer = () => {
  const { isLoading, isSignedIn, account } = useAccount();
  const { locale } = useLocale();
  const { query } = useRouter();
  // This is set when the user is redirected from an external source like Grip SSO
  const afterSignInUrl =
    query['redirect_url']?.toString() ??
    addLocalePrefix(locale, Routes.Account);

  if (isLoading || (isSignedIn && !account)) {
    return <LoadingScreen />;
  }

  return (
    <>
      {/* Mobile */}
      <AccountNavigation />
      {/* Desktop */}
      <PageBreadcrumbs
        items={[{ label: <FormattedMessage id="account.profile.label" /> }]}
        hideOnMobile
      />
      <Container
        sx={{
          mt: { xs: 1, md: 3 },
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: { xs: 'flex', md: 'grid' },
            gridTemplateColumns: { xs: '1fr', md: '6fr 1fr 5fr' },
            alignContent: 'stretch',
            gap: 2,
            flex: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: { xs: 1, md: 0 },
                mb: { xs: 3, md: 5 },
              }}
            >
              {isSignedIn ? (
                <AuthenticatedSection />
              ) : (
                <Authentication
                  titleIntlId="account.sign.in.profile.label"
                  afterSignInUrl={afterSignInUrl}
                  originSourceCategory="Profile"
                />
              )}
            </Box>
            <SettingLinksList />
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
              flex: 1,
            }}
          />
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
              flex: 1,
            }}
          >
            {isSignedIn && <DownloadApp />}
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default AccountContainer;
